import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStop"><Path d="M20.5 20.5V3.5H3.5V20.5H20.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconStop;
